/**
 * Gallery Configuration
 * Central configuration for the infinite canvas gallery
 */

export const galleryConfig = {
  // Canvas pan/zoom settings
  canvas: {
    minZoom: 0.25,      // Zoomed out (shows ~400 images max for performance)
    maxZoom: 4,         // Zoomed way in
    defaultZoom: 0.5,   // Start at 50%
    zoomStep: 0.2,      // Scroll wheel increment
  },

  // Image display settings
  images: {
    // Which resolution to load based on zoom level
    // Conservative loading - don't load high quality too early
    zoomThresholds: {
      thumbnail: 0.4,   // zoom < 40% = thumbnail only (good for overview)
      medium: 1.0,      // 40% <= zoom < 100% = medium (1200px)
      full: 1.0,        // zoom >= 100% = full resolution (4000px) - only when really zoomed in
      original: 999     // original reserved for future modal view (never auto-load in gallery)
    },
    viewportBuffer: 800,  // Load images 800px outside viewport
  },

  // Grid layout settings (hexagonal honeycomb from center)
  grid: {
    columns: {
      mobile: 2,
      tablet: 3,
      desktop: 4,
    },
    baseSize: 300,      // Base size for grid cells (px)
    gap: 4,             // Gap between images (px) - adjust: 0=touching, 16=spaced, 30+=large gaps
  },

  // API settings
  api: {
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  },

  // Progressive loading settings
  loading: {
    blurTransitionMs: 300,
    maxRetries: 2,
  }
}

export default galleryConfig
